var exports = {
  "Y": "projectLink__kH7qaz",
};

module.exports = exports;
